import {Environment} from "platform/enum/Environment";
import {Logger} from "platform/logger/Logger";
import {BITracker} from "platform/analytics/BITracker";

export class BITrackerWeb implements BITracker {

    private static _instance: BITracker;
    private readonly _logger: Logger = Logger.Of("BITracker");
    private _initialized: boolean;
    private _identified: boolean;

    private constructor() {
    }

    public static instance(): BITracker {
        return this._instance || (this._instance = new this());
    }

    public init = (token: string) => {
        if (Environment.isProd()) {
            if (!this._initialized) {
                this._initialized = true;
                this.load().then((mixpanel) => {
                    mixpanel.init(token, {debug: !Environment.isProd()});
                });
            } else {
                this._logger.warn("Already initialized");
            }
        }
    }

    public identify = (userId: number) => {
        if (Environment.isProd()) {
            if (this._initialized) {
                if (!this._identified) {
                    this._identified = true;
                    this.load().then((mixpanel) => {
                        mixpanel.identify(userId);
                    });
                } else {
                    this._logger.warn("Already identified");
                }
            } else {
                this._logger.warn("Can't identify. Not initialized");
            }
        }
    }

    public track = (event: string, data?: any) => {
        if (Environment.isProd()) {
            if (this._identified) {
                this.load().then((mixpanel) => {
                    mixpanel.track(event, data);
                });
            } else {
                this._logger.warn(`Can't track event: ${event}. Not identified`);
            }
        }
    }

    private load = async () => {
        return await import('mixpanel-browser');
    }
}
